import { z } from 'zod'

const REGISTER_CARD_RESULT_CODES = {
  /** @description Success */
  OK: 'OK',
  /** @description Invalid card type */
  INVALID_CARD_TYPE: 'INVALID_CARD_TYPE',
  /** @description Invalid card expiration date */
  INVALID_CARD_EXPIRATION: 'INVALID_CARD_EXPIRATION',
  /** @description Rejected card company */
  REJECT_CARD_COMPANY: 'REJECT_CARD_COMPANY',
  /** @description Invalid card identity */
  INVALID_CARD_IDENTITY: 'INVALID_CARD_IDENTITY',
  /** @description Maximum authentication count exceeded */
  EXCEED_MAX_AUTH_COUNT: 'EXCEED_MAX_AUTH_COUNT',
  /** @description Invalid card */
  INVALID_CARD: 'INVALID_CARD',
} as const

export const rawRegisterCardResSchema = z.object({
  resultCd: z.number(),
  resultCdName: z.enum([REGISTER_CARD_RESULT_CODES.OK]),
  resultMsg: z.string(),
  data: z.string(),
})

export const rawRegisterCardFailResSchema = z.object({
  resultCd: z.number(),
  resultCdName: z.enum([
    REGISTER_CARD_RESULT_CODES.INVALID_CARD_TYPE,
    REGISTER_CARD_RESULT_CODES.INVALID_CARD_EXPIRATION,
    REGISTER_CARD_RESULT_CODES.REJECT_CARD_COMPANY,
    REGISTER_CARD_RESULT_CODES.INVALID_CARD_IDENTITY,
    REGISTER_CARD_RESULT_CODES.EXCEED_MAX_AUTH_COUNT,
    REGISTER_CARD_RESULT_CODES.INVALID_CARD,
  ]),
  message: z.string(),
  data: z.null(),
})

export type RegisterCardResultCode = keyof typeof REGISTER_CARD_RESULT_CODES
export type RawRegisterCardRes = z.infer<typeof rawRegisterCardResSchema>
export type RawRegisterCardFailRes = z.infer<typeof rawRegisterCardFailResSchema>
